"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    a11yLabel: 'Read legal footnote',
    close: 'close',
    heading: 'Terms and conditions'
  },
  fr: {
    a11yLabel: 'Lire la note de bas de page légale',
    close: 'fermer',
    heading: 'Modalités et conditions'
  }
};